import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ADMIN_API } from "../../common/common";
import { getImageUrl, Logout } from "../../common/Funcation";
import { styleObjectBlackButton } from "../../common/StyleSeter";
import Pagination from "../../components/Pagination";
import Loader from "../../components/Loader";
import { getApi, postApi } from "../../service";
import { dataInterface } from "./interface";

export const BANNER_WEBSITE_STORAGE_KEY = "selectedBannerWebsiteId";

const readStoredWebsiteId = () => {
  try {
    return sessionStorage.getItem(BANNER_WEBSITE_STORAGE_KEY) || "";
  } catch {
    return "";
  }
};

function ManageBanner() {
  const DD = useSelector((e: any) => e.domainDetails);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [isLoader, setLoader] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [hoverId, setHoverId] = useState({ isHover: "" });
  const [siteDropDownData, setSiteDropDownData] = useState<any>([]);
  const [webSiteId, setWebSiteIdData] = useState<string>(
    () => searchParams.get("website") || readStoredWebsiteId(),
  );
  const [pageData, setPageData] = useState<any>({});
  const [currentPage, setCurrentPage] = useState<number>(1);

  const handleMouseEnter = (id: string = "") => {
    if (id) setHoverId({ isHover: id });
    else setIsHover(true);
  };
  const handleMouseLeave = (id: string = "") => {
    if (id) setHoverId({ isHover: "" });
    else setIsHover(false);
  };

  const persistWebsiteId = (value: string) => {
    setWebSiteIdData(value);
    try {
      if (value) sessionStorage.setItem(BANNER_WEBSITE_STORAGE_KEY, value);
      else sessionStorage.removeItem(BANNER_WEBSITE_STORAGE_KEY);
    } catch {}
    if (value) setSearchParams({ website: value }, { replace: true });
    else setSearchParams({}, { replace: true });
  };

  const getIdForWebSite = (e: any) => {
    persistWebsiteId(e.target.value);
  };

  useEffect(() => {
    getSiteDropDownData();
  }, []);

  const getSiteDropDownData = async () => {
    const data = { api: ADMIN_API.SETTING.WEBSITE.GET_DOMAIN };
    await getApi(data)
      .then(function (response) {
        const sites = response.data.data || [];
        setSiteDropDownData(sites);

        const storedId = searchParams.get("website") || readStoredWebsiteId();
        const storedExists =
          storedId && sites.some((item: any) => item?._id === storedId);
        if (storedExists) {
          persistWebsiteId(storedId);
        } else if (sites.length === 1) {
          persistWebsiteId(sites[0]._id);
        } else if (storedId && !storedExists) {
          persistWebsiteId("");
        }
      })
      .catch((err) => {
        if (err.response?.data?.statusCode === 401) {
          Logout();
          navigate("/login");
        }
      });
  };

  useEffect(() => {
    if (webSiteId !== "") getPageData("1");
    else setPageData({});
  }, [webSiteId]);

  const getPageData = async (PAGE: string) => {
    const pageNum = Number(PAGE) || 1;
    setCurrentPage(pageNum);
    setLoader(true);
    const data: dataInterface = {
      api: ADMIN_API.SETTING.BANNER.GET_LIST,
      value: {
        page: PAGE || "1",
        limit: "50",
        domain: webSiteId,
      },
    };
    await postApi(data)
      .then(function (response) {
        setPageData(response.data.data);
      })
      .catch((err) => {
        if (err.response?.data?.statusCode === 401) {
          Logout();
          navigate("/login");
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const showAlert = async (id: string) => {
    if (window.confirm("Are you sure you want to delete this item?") === true) {
      const data: any = {
        api: ADMIN_API.SETTING.BANNER.DELETE,
        value: { id },
      };
      await postApi(data)
        .then(() => getPageData("1"))
        .catch((err) => {
          if (err.response?.data?.statusCode === 401) {
            Logout();
            navigate("/login");
          }
        });
    }
  };

  const editClick = (item: any) => {
    navigate("/edit-banner/" + item._id, {
      state: { websiteDomain: webSiteId },
    });
  };

  const handlePageClick = (e: any) => {
    getPageData((e.selected + 1).toString());
  };

  return (
    <div className="container settings main_wrap">
      {isLoader && <Loader />}
      {/* Header */}
      <div className="top_header">
        <div className="top_header_title mt-3 d_flex d_flex_justify_spacebt">
          <h5>Manage Banner Images</h5>
          {webSiteId && (
            <a
              href={"/add-banner/" + webSiteId}
              onMouseEnter={() => handleMouseEnter()}
              onMouseLeave={() => handleMouseLeave()}
              style={styleObjectBlackButton(DD?.colorSchema, isHover)}
              className="btn_black d_flex d_flex_align_center"
            >
              Add New
            </a>
          )}
        </div>

        {/* Website selector */}
        <div
          className="d_flex d_flex_align_center"
          style={{ marginTop: "8px" }}
        >
          <label
            style={{ marginRight: "8px", fontWeight: 500, fontSize: "13px" }}
          >
            Select Website:
          </label>
          <select
            style={{ height: "32px", width: "160px" }}
            id="website-select"
            value={webSiteId}
            onChange={(e) => getIdForWebSite(e)}
          >
            <option value="">Select Website</option>
            {siteDropDownData?.length > 0 &&
              siteDropDownData.map((item: any) => (
                <option key={item?._id} value={item?._id}>
                  {item?.domain}
                </option>
              ))}
          </select>
        </div>
      </div>

      {/* Table */}
      <table className="table01 margin-table">
        <thead>
          <tr className="light-grey-bg">
            <th style={{ width: "8%" }}>S.No</th>
            <th style={{ width: "30%" }}>Image</th>
            <th style={{ width: "30%" }}>Name</th>
            <th style={{ width: "30%" }}>Status</th>
            <th style={{ width: "8%" }}>Action</th>
          </tr>
        </thead>
        <tbody id="matches-table">
          {pageData.results && pageData.results?.length > 0 ? (
            pageData.results.map((item: any, i: number) => (
              <tr key={item?._id || i}>
                <td>{(currentPage - 1) * 50 + (i + 1)}</td>
                <td style={{ padding: "8px 10px" }}>
                  <a
                    href={getImageUrl(item.image)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={getImageUrl(item.image)}
                      alt={item.name}
                      style={{
                        height: "48px",
                        maxWidth: "120px",
                        objectFit: "cover",
                        borderRadius: "4px",
                        border: "1px solid #e0e0e0",
                      }}
                    />
                  </a>
                </td>

                {/* Name */}
                <td style={{ padding: "8px 10px", fontWeight: 500 }}>
                  {item.name}
                </td>

                {/* Status */}
                <td style={{ padding: "8px 10px" }}>
                  <span
                    style={{
                      display: "inline-block",
                      padding: "2px 12px",
                      borderRadius: "12px",
                      fontSize: "12px",
                      fontWeight: 600,
                      background: item.active ? "#e6f9f0" : "#fdecea",
                      color: item.active ? "#1a7a4a" : "#b71c1c",
                      border: `1px solid ${item.active ? "#b7e4ce" : "#f5c6c0"}`,
                    }}
                  >
                    {item.active ? "On" : "Off"}
                  </span>
                </td>

                {/* Actions */}
                <td style={{ padding: "8px 10px" }}>
                  <div className="d_flex" style={{ gap: "6px" }}>
                    <button
                      onClick={() => editClick(item)}
                      onMouseEnter={() => handleMouseEnter(item._id)}
                      onMouseLeave={() => handleMouseLeave(item._id)}
                      style={styleObjectBlackButton(
                        DD?.colorSchema,
                        hoverId.isHover === item._id,
                      )}
                      className="btn_black"
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      className="btn_red"
                      onClick={() => showAlert(item._id)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        style={{ width: "11px" }}
                      >
                        <path
                          fill="#ffffff"
                          d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
                        />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={5}
                style={{
                  textAlign: "center",
                  padding: "40px 0",
                  color: "#9e9e9e",
                  fontSize: "15px",
                }}
              >
                {webSiteId
                  ? "No banners found"
                  : "Please select a website to view banners"}
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="d_flex d_flex_align_center w_100 d_flex_justify_center">
        {pageData?.totalPages > 1 && (
          <Pagination
            handlePageClick={handlePageClick}
            totalPages={pageData?.totalPages}
          />
        )}
      </div>
    </div>
  );
}

export default ManageBanner;
